import React from "react";
import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center rounded-b-3xl shadow-lg">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-bold mb-6"
        >
          WHO WE ARE?
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mx-auto text-lg opacity-90" //max-w-2xl 
        >
          We empower businesses with innovative infrastructure and technology
          solutions — reliable, scalable, and future-ready.
        </motion.p>
      </div>

      {/* Cards Section */}
      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {/* About Us */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-white shadow-lg rounded-2xl p-8 border-t-8 border-yellow-500 hover:shadow-2xl transition"
        >
          <h4 className="text-2xl font-bold text-center text-yellow-600 mb-4">
            About Us
          </h4>
          <p className="text-gray-700 text-justify leading-relaxed">
            DTEC is a trusted partner in infrastructure and technology,
            delivering tailored solutions across telecom, energy, education, and
            government sectors.
          </p>
        </motion.div>

        {/* Vision */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
          className="bg-white shadow-lg rounded-2xl p-8 border-t-8 border-blue-500 hover:shadow-2xl transition"
        >
          <h4 className="text-2xl font-bold text-center text-blue-600 mb-4">
            Vision
          </h4>
          <p className="text-gray-700 text-justify leading-relaxed">
            To be the leading provider of innovative, reliable, and scalable
            technology solutions that shape smarter, connected communities.
          </p>
        </motion.div>

        {/* Mission */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="bg-white shadow-lg rounded-2xl p-8 border-t-8 border-indigo-600 hover:shadow-2xl transition"
        >
          <h4 className="text-2xl font-bold text-center text-indigo-700 mb-4">
            Mission
          </h4>
          <p className="text-gray-700 text-justify leading-relaxed">
            Deliver high-quality, customized solutions through strong
            partnerships, skilled teams, and a commitment to excellence.
          </p>
        </motion.div>

        {/* Core Values */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1 }}
          viewport={{ once: true }}
          className="bg-white shadow-lg rounded-2xl p-8 border-t-8 border-purple-600 hover:shadow-2xl transition md:col-span-2 lg:col-span-3"
        >
          <h4 className="text-2xl font-bold text-center text-purple-600 mb-6">
            Core Values
          </h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-gray-700">
            <li>✔ Excellence</li>
            <li>✔ Innovation</li>
            <li>✔ Integrity</li>
            <li>✔ Customer Focus</li>
            <li>✔ Partnership</li>
            <li>✔ Continuous Improvement</li>
          </ul>
        </motion.div>

        {/* Company Profile Download */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration : 1.2 }}
          viewport={{ once: true }}
          className="bg-white shadow-lg rounded-2xl p-8 border-t-8 border-green-600 hover:shadow-2xl transition md:col-span-2 lg:col-span-3 text-center"
        >
          <h4 className="text-2xl font-bold text-green-600 mb-4">
            Learn More About Us
          </h4>
          <p className="text-gray-700 mb-6">
          For more details about our company and services, you can download our full Company Profile.
          </p>
          <a
            href="https://drive.google.com/file/d/1KosL33974yHoljbb1kZB5y8DOsS5Z-PB/view?usp=sharing" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 text-white px-6 py-3 rounded-xl shadow-md hover:bg-green-700 transition font-medium"
          >
            View Company Profile
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
